// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react';
import { bemComponent } from '@99designs/frontend-components/utils/app';

/**
 * @deprecated replaced by `Modal` or `Overlay` in `@99designs/emu`
 */
export const ModalHeader = bemComponent('modal__header');
/**
 * @deprecated replaced by `Modal` or `Overlay` in `@99designs/emu`
 */
export const ModalBody = bemComponent('modal__body');
